<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备保养记录</el-breadcrumb-item>
    </el-breadcrumb>
    <MaintainanceList :all="true"></MaintainanceList>
  </div>
</template>


<script>
import MaintainanceList from '../customer/maintainance.vue'

export default {
  components: {
    MaintainanceList,
  },
}
</script>